import { deriveSlot, personBondLine, statusMeta, typeLabel } from './agenda-adapter';

import type { AppointmentWireItem } from '../../lib/api-client';
import type { JSX } from 'react';

/**
 * AppointmentCard — card da agenda extendida (porta `.appt-card`). Campos REAIS
 * apenas: title + type + Pessoa·Bond (§4, quando vinculado) + status + endereço
 * + badge "Reagendado" (D2 — por `rescheduledFromId`, sem contador fabricado).
 */
export function AppointmentCard({
  appt,
  onOpen,
}: {
  appt: AppointmentWireItem;
  onOpen: (appt: AppointmentWireItem) => void;
}): JSX.Element {
  const slot = deriveSlot(appt);
  const meta = statusMeta(appt.status);
  // "tipo · Nome · Bond" — partes vazias somem (avulso ⇒ só o tipo).
  const subtitle = [typeLabel(appt.type), personBondLine(appt)].filter((p) => p !== '').join(' · ');
  return (
    <article
      className={`appt-card appt-card--${meta.tone}`}
      role="button"
      tabIndex={0}
      onClick={() => onOpen(appt)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onOpen(appt);
        }
      }}
    >
      <span className="appt-card__time">
        {slot.start} – {slot.end}
      </span>
      <h3 className="appt-card__title">{appt.title}</h3>
      <span className="appt-card__person">{subtitle}</span>
      <div className="appt-card__meta">
        <span>{meta.label}</span>
        {appt.addressOrLocation !== null && appt.addressOrLocation.trim().length > 0 && (
          <>
            <span>·</span>
            <span>{appt.addressOrLocation}</span>
          </>
        )}
        {appt.rescheduledFromId !== null && (
          <>
            <span>·</span>
            <span>Reagendado</span>
          </>
        )}
      </div>
    </article>
  );
}
